import debounce from 'lodash.debounce'

export default {
  watch: {
    loading: {
      async handler () {
        await nextTick()
        this._tableResize_fullAutoSize()
      },
      immediate: true
    }
  },
  unmounted () {
    window.removeEventListener('resize', this._tableResize_fullAutoSize)
  },
  methods: {
    _setupTableResize () {
      window.addEventListener('resize', this._tableResize_fullAutoSize)
      this.gridOptions.api.addEventListener('columnVisible', this._tableResize_fullAutoSize)
      this.gridOptions.api.addEventListener('columnGroupOpened', this._tableResize_fullAutoSize)
    },
    _tableResize_autoSizeAllColumns () {
      if (this.loading) return

      // Optional Chaining prevents console errors, as this function triggered before gridOptions.api
      // is initialized by the asynchronous ag-grid `grid-ready` callback event.
      this.gridOptions.api?.autoSizeAllColumns()

      // This is a fix for a bug in ag-grid-vue where the
      // ag-column-resizing class is not removed from the DOM
      // after autoSizeAllColumns is called.
      document.querySelectorAll('.ag-column-resizing')
        .forEach(node => node.classList.remove('ag-column-resizing'))
    },
    _tableResize_sizeColumnsToFit: debounce(function () {
      if (this.loading) return

      // Optional Chaining prevents console errors, as this function triggered before gridOptions.api
      // is initialized by the asynchronous ag-grid `grid-ready` callback event.
      this.gridOptions.api?.sizeColumnsToFit()
    }, 200),
    _tableResize_fullAutoSize () {
      this._tableResize_autoSizeAllColumns()
      this._tableResize_sizeColumnsToFit()
    }
  }
}
